<template>
  <div class="read-only company-read-only">
    <div class="d-flex flex-column ">
      <label class="text-black">
        Name
      </label>
      <form-control
        v-model="company.name"
        readonly
      />
    </div>

    <div class="d-flex flex-column">
      <label class="text-black">
        Short Name
      </label>

      <form @submit.prevent="save">
        <div class="d-flex w-100">
          <form-control
            class="w-100"
            v-model="company.short_name"
            :readonly="!canEdit"
          />
        </div>
      </form>
    </div>

    <div
      v-if="company.country"
      class="d-flex flex-column "
    >
      <label class="text-black">
        Country
      </label>
      <form-control
        v-model="company.country.tag.name"
        readonly
      />
    </div>

    <div
      v-if="company.micro_sector"
      class="d-flex flex-column "
    >
      <label class="text-black">
        Industry
      </label>
      <form-control
        :value="`${company.micro_sector.sector.name} — ${company.micro_sector.name}`"
        readonly
      />
    </div>

    <div
      v-if="company.website"
      class="d-flex flex-column "
    >
      <label class="text-black">
        Website
      </label>
      <form-control
        :value="company.website"
        readonly
      />
    </div>

    <div
      class="d-flex flex-column "
    >
      <label class="text-black">
        Address
      </label>
      <form-control
        v-if="address"
        :value="address"
        readonly
      />
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="w-100 mt-4 py-4 d-flex border-top">
      <button
        v-if="$login.can('companies.delete')"
        class="btn btn-outline-danger "
        @click="$modal.show('confirm-delete')"
      >
        Delete
      </button>

      <button
        class="ml-auto btn btn-primary "
        @click="save"
      >
        Save
      </button>
    </div>
    <confirm
      :name="company.name"
      @confirmed="deleteCompany"
    />
  </div>
</template>

<script>
import {successNotification} from '@/notifications'
import Confirm from '@/components/Confirm'

export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
    canEdit: {
      required: true,
      type: Boolean,
    },
  },

  components: {
    Confirm,
  },

  data () {
    return {
      address: null,
      ticker: null,
      isin: null,
      lei: null,
    }
  },

  async mounted () {
    // const {data} = await this.$http.get(`/companies/rapido/legacy/${this.company.id}`)
    // if (data.company1) {
    //   this.address = data.company1['companyAddress;']
    //   this.ticker = data.company1.tickerPartial
    //   this.isin = data.company1.securityIdISIN
    //   this.lei = data.company1.companyLEIName
    // }
  },

  methods: {
    async save () {
      await this.$http.put(`/companies/${this.company.id}`, {
        short_name: this.company.short_name,
      })

      this.$notify(successNotification('Updated short name'))
    },

    async deleteCompany () {
      await this.$http.delete(`/companies/${this.company.id}`)

      this.$notify(successNotification(`Deleted ${this.company.name}`))
      this.$router.go(-1)
    },
  },
}
</script>

